import GReporter from '../../3rd/grafana-reporter'

GReporter.setConfig({
  Debug: false, // 是否打开日志，可选，默认 false
  OpenReport: true, // 是否打开上报，可选，默认 true
  BaseInfo: {
    uid: 0,
    ua: `hyext@1.0.0`, // 所属平台的ua
  },
})


export const report = (metricName: string, dim: {
  [key: string]: string
}, field: {
  [key: string]: number
}) => {
  console.log('[tracking]-------------------------------')
  const reportInfo = {
    metricName,
    dim,
    field,
  }
  console.log('[tracking]reportInfo', reportInfo)
  console.log('[tracking]-------------------------------')
  GReporter.report(reportInfo)
}